import React from 'react';

const BusinessBtn = () => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Icons'>
        <g id='Group'>
          <g id='briefcase'>
            <path
              id='Shape'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M21 22.9852H3C1.34315 22.9852 0 21.6037 0 19.8995V8.58519C0 6.881 1.34315 5.49948 3 5.49948H6.9C7.02491 5.4979 7.12952 5.40172 7.145 5.27422L7.289 4.08828C7.47662 2.54399 8.75293 1.38511 10.266 1.38519H13.734C15.2459 1.38667 16.5205 2.54516 16.708 4.08828L16.852 5.27422C16.8676 5.40288 16.9739 5.49944 17.1 5.49948H21C22.6569 5.49948 24 6.881 24 8.58519V19.8995C24 21.6037 22.6569 22.9852 21 22.9852ZM10.266 3.44234C9.76139 3.44196 9.33557 3.82834 9.273 4.34336L9.168 5.21148C9.15942 5.28449 9.18164 5.35778 9.22905 5.41283C9.27645 5.46788 9.3445 5.49942 9.416 5.49948H14.584C14.6555 5.49942 14.7235 5.46788 14.771 5.41283C14.8184 5.35778 14.8406 5.28449 14.832 5.21148L14.727 4.34336C14.6644 3.82834 14.2386 3.44196 13.734 3.44234H10.266ZM5.25 11.1566C5.25 10.7306 5.58579 10.3852 6 10.3852H18C18.4142 10.3852 18.75 10.7306 18.75 11.1566V11.6709C18.75 12.097 18.4142 12.4423 18 12.4423H6C5.58579 12.4423 5.25 12.097 5.25 11.6709V11.1566ZM6 16.0423C5.58579 16.0423 5.25 16.3877 5.25 16.8138V17.3281C5.25 17.7541 5.58579 18.0995 6 18.0995H18C18.4142 18.0995 18.75 17.7541 18.75 17.3281V16.8138C18.75 16.3877 18.4142 16.0423 18 16.0423H6Z'
              fill='#8D8D8C'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BusinessBtn;
